import { useMemo } from "react";
export const useRenderPassInfoText = (param)=>{
    let { pass  } = param;
    const UNLIMITED_PRICE = 999999;
    const isUnlimitedMaxPrice = useMemo(()=>pass.availableMaxPrice && pass.availableMaxPrice === UNLIMITED_PRICE, [
        pass
    ]);
    const isAvailableMaxPrice = useMemo(()=>!isUnlimitedMaxPrice && pass.availableMaxPrice !== 0, [
        pass
    ]);
    const isNoDiscount = useMemo(()=>{
        return pass.discountRate === 0;
    }, [
        pass
    ]);
    return {
        isUnlimitedMaxPrice,
        isAvailableMaxPrice,
        isNoDiscount
    };
};
